import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const DisplayMapPage = lazy(() => import('@/pages/DisplayMap'))

export const Route = createFileRoute('/display/live-map')({
  component: function DisplayLiveMapRoute() {
    return (
      <Suspense fallback={<div style={{ background: '#0f1a24', height: '100vh' }} />}>
        <DisplayMapPage />
      </Suspense>
    )
  },
})
